import { useEffect, useRef } from 'react';
import './Secondary.css';
import { useOutletContext } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Parser from 'html-react-parser';

function Secondary() {
    const pageJSON = useOutletContext()
    const subjectsRef = useRef(null)
    const engElem = useRef(null)
    const mathElem = useRef(null)
    const sciElem = useRef(null)
    const chiElem = useRef(null)
    const htmlElement = document.documentElement
    const url_domain = pageJSON ? pageJSON["url_domain"] : null

    useEffect(() => {
        htmlElement.style.setProperty('--YELLOW-elem-height', engElem.current.offsetHeight + 'px');
        htmlElement.style.setProperty('--BLUE-elem-height', mathElem.current.offsetHeight + 'px');
        htmlElement.style.setProperty('--GREEN-elem-height', sciElem.current.offsetHeight + 'px');
        htmlElement.style.setProperty('--GRAY-elem-height', chiElem.current.offsetHeight + 'px');

        const observer = new IntersectionObserver(
            subjects => {
                for (let i = subjects.length - 1; i >= 0; i--) {
                    const subject = subjects[i]
                    console.log(subject.target.getBoundingClientRect().height)
                    if (subject.isIntersecting) {
                        subject.target.classList.add("opened")
                        observer.unobserve(subject.target)
                    }
                }
            },
            {
                "rootMargin": "-0px 0px -250px 0px",
                "threshold": 0.1
            }
        );

        const resize_observer = new ResizeObserver(
            subjects => {
                for (let i = subjects.length - 1; i >= 0; i--) {
                    const subject = subjects[i]
                    htmlElement.style.setProperty('--'+subject.target.classList[0]+'-elem-height', subject.target.getBoundingClientRect().height + 'px');
                }
            }
        );
        
        subjectsRef.current.querySelectorAll(".subject-contents-wrapper:not(.YELLOW)").forEach((subject) => {
            observer.observe(subject)
        })
        subjectsRef.current.querySelectorAll(".subject-contents-wrapper").forEach((subject) => {
            resize_observer.observe(subject)
        })
        return () => observer.disconnect();
    }, [])

    return (
        <div className="main">
            <div id='banner'>
                <img src='images/page-banners/secondary-banner.png' id='banner-img'/>
                <div id='banner-title'>Secondary</div>
            </div>

            <div className='center-content'>
                <Breadcrumbs></Breadcrumbs>
                <div id='subject-stack-wrapper' ref={subjectsRef}>
                    <div className='YELLOW subject-contents-wrapper learn-more-hidden' ref={engElem} id='english-sub'>
                        <div className="subjects YELLOW subject-content-subject">
                            <h2>ENGLISH</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                                <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["secondary"]["ENGLISH"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["secondary"]["ENGLISH"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["secondary"]["ENGLISH"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["secondary"]["ENGLISH"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        engElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["secondary"]["ENGLISH"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='BLUE subject-contents-wrapper learn-more-hidden' id='math-sub' ref={mathElem}>
                        <div className="subjects BLUE subject-content-subject">
                            <h2>MATH</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                                <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["secondary"]["MATH"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["secondary"]["MATH"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["secondary"]["MATH"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["secondary"]["MATH"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        mathElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["secondary"]["MATH"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='GREEN subject-contents-wrapper learn-more-hidden' id='science-sub' ref={sciElem}>
                        <div className="subjects GREEN subject-content-subject">
                            <h2>SCIENCE</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                            <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["secondary"]["SCIENCE"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["secondary"]["SCIENCE"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["secondary"]["SCIENCE"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["secondary"]["SCIENCE"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        sciElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["secondary"]["SCIENCE"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='GRAY subject-contents-wrapper learn-more-hidden' id='chinese-sub' ref={chiElem}>
                        <div className="subjects GRAY subject-content-subject">
                            <h2>CHINESE</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                            <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["secondary"]["CHINESE"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["secondary"]["CHINESE"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["secondary"]["CHINESE"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["secondary"]["CHINESE"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        chiElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["secondary"]["CHINESE"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row-wrapper">
                        <button id='contact-us-btn' onClick={() => {
                            window.location.href="https://api.whatsapp.com/send?phone=6598206604"
                        }}>
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Secondary;